"use strict";

exports.__esModule = true;
exports.NavbarItem = exports.Navbar = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _core = require("@blueprintjs/core");
var _NavbarTitle = require("./NavbarTitle");
var _Theme = require("../../Theme");
var _excluded = ["title", "subTitle", "leftContent", "children"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var StyledNavbar = (0, _styledComponents["default"])(_core.Navbar).withConfig({
  displayName: "Navbar__StyledNavbar",
  componentId: "sc-fl0piz-0"
})(["&.", "{padding:", ";height:", ";max-height:", ";border-left:none;flex-shrink:0;display:flex;align-items:center;overflow:hidden;}&.", ".", "{background-color:", ";}"], _core.Classes.NAVBAR, (0, _Theme.val)("NavbarPadding"), (0, _Theme.val)("NavbarHeight"), (0, _Theme.val)("NavbarHeight"), _core.Classes.NAVBAR, _core.Classes.DARK, (0, _Theme.val)("NavbarBackgroundColor"));
var NavbarInner = _styledComponents["default"].div.withConfig({
  displayName: "Navbar__NavbarInner",
  componentId: "sc-fl0piz-1"
})(["flex:1;"]);
var NavbarItem = exports.NavbarItem = _styledComponents["default"].div.withConfig({
  displayName: "Navbar__NavbarItem",
  componentId: "sc-fl0piz-2"
})(["display:inline;margin-right:1rem;"]);

/**
 * A wrapper around blueprint's Navbar.
 */

var Navbar = exports.Navbar = (0, _styledComponents.withTheme)(function (props) {
  var title = props.title,
    subTitle = props.subTitle,
    leftContent = props.leftContent,
    children = props.children,
    extra = _objectWithoutPropertiesLoose(props, _excluded);
  var hasContent = Boolean(leftContent || children);
  var headingStyle = hasContent ? {
    maxWidth: 500
  } : {};
  var isDark = props.theme.NavbarBackgroundTheme === "dark";
  return /*#__PURE__*/_react["default"].createElement(StyledNavbar, _extends({
    className: isDark ? _core.Classes.DARK : "",
    "data-testid": "Navbar"
  }, extra), /*#__PURE__*/_react["default"].createElement(NavbarInner, null, title && /*#__PURE__*/_react["default"].createElement(_core.NavbarGroup, {
    align: _core.Alignment.LEFT
  }, /*#__PURE__*/_react["default"].createElement(_core.NavbarHeading, null, /*#__PURE__*/_react["default"].createElement(_NavbarTitle.NavbarTitle, {
    title: title,
    subTitle: subTitle,
    style: headingStyle
  }))), leftContent && /*#__PURE__*/_react["default"].createElement(_core.NavbarGroup, {
    align: _core.Alignment.LEFT
  }, leftContent), children && /*#__PURE__*/_react["default"].createElement(_core.NavbarGroup, {
    align: _core.Alignment.RIGHT
  }, children)));
});